module.exports = __webpack_public_path__ + "img/郑州仓库.c5380d9d.jpg";